import { mockOfficeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-general-actions';
const CONV_ID = 'conv-6';
const MD_BLOCK_ID = 'blk-ga-md';
const markdownText = 'You have **12 inspections** scheduled for this week across 3 buildings. ' +
    'Building A has 5, Building B has 4, and Building C has 3. ' +
    'All inspectors have been notified and equipment is ready.';
const suggestedActions = [
    { action: 'query', label: 'Show me the full schedule', params: {} },
    { action: 'query', label: 'Which inspectors are assigned?', params: {} },
    { action: 'navigate', label: 'Open calendar', params: { url: '/calendar' } }
];
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockOfficeAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText, 20, 60),
    makeBlockEnd(MD_BLOCK_ID),
    makeStreamEnd(RESPONSE_ID, 1, mockOfficeAgent, 400)
];
export const scenario = {
    name: 'Office Assistant — General Actions',
    description: 'Simple response that completes quickly to exercise the GeneralActions controls ' +
        '(copy, thumbs up/down, retry, share) rendered below every completed agent message.',
    conversations: mockConversations,
    userMessage: 'How many inspections are scheduled this week?',
    agentIdentity: mockOfficeAgent,
    sseSequence,
    suggestedActions
};
